import {Component} from '@angular/core';
import {ICellRendererAngularComp} from "ag-grid-angular";
import {ICellRendererParams} from "ag-grid-community";
import {MatButton} from "@angular/material/button";
import {ICausablePayment} from "../../interfaces/causable/ICausablePayment";

interface IVoidRemittanceParams extends ICellRendererParams<ICausablePayment> {
  onVoidClick: (causablePaymentIdP: string) => void;
}

/**
 * Void action for a remittance row. Hidden on already-voided rows — voiding twice is refused by the
 * backend, and offering the button anyway just invites the error.
 */
@Component({
  selector: 'app-void-remittance-action',
  standalone: true,
  imports: [MatButton],
  template: `
    @if (payment && !payment.Voided) {
      <button mat-stroked-button
              color="warn"
              type="button"
              [attr.data-testid]="'void-remittance-button'"
              (click)="onClick()">
        Void
      </button>
    }
  `
})
export class VoidRemittanceActionComponent implements ICellRendererAngularComp {

  public payment: ICausablePayment | undefined;
  private params!: IVoidRemittanceParams;

  agInit(params: IVoidRemittanceParams): void {
    this.params = params;
    this.payment = params.data;
  }

  refresh(params: IVoidRemittanceParams): boolean {
    this.params = params;
    this.payment = params.data;

    return true;
  }

  onClick(): void {
    if (this.payment) {
      this.params.onVoidClick(this.payment.Id);
    }
  }
}
